import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "soilMoisture1";
const UNIT = "kPa";

const SoilMoisture1: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT}></SensorBase>
    </div>
  );
};

export default SoilMoisture1;